import React from 'react';
import withIcon from '../utilities/withIcon';

const IconSlidersVert = () => {
  return (
    <g>
      <path d="M3.897 8c.4 0 .724.336.724.75v6.5c0 .414-.325.75-.724.75a.737.737 0 0 1-.725-.75v-6.5c0-.414.325-.75.725-.75zm8.206 4c.4 0 .725.336.725.75v2.5c0 .414-.325.75-.725.75a.737.737 0 0 1-.724-.75v-2.5c0-.414.325-.75.724-.75zm-2.172-1.5a.737.737 0 0 1-.724-.75c0-.414.324-.75.724-.75h1.448V.75c0-.414.325-.75.724-.75.4 0 .725.336.725.75V9h1.448c.4 0 .724.336.724.75s-.324.75-.724.75H9.93zM3.897 0c.4 0 .724.336.724.75V5h1.448c.4 0 .724.336.724.75s-.324.75-.724.75H1.724A.737.737 0 0 1 1 5.75c0-.414.324-.75.724-.75h1.448V.75c0-.414.325-.75.725-.75z" />
    </g>
  );
};

export default withIcon(IconSlidersVert);
